import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-950 border-t border-amber-500/15">
      {/* Gold top accent line */}
      <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-500/40 to-transparent"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-5">
              <img
                src="https://static.readdy.ai/image/1aff587802347e8a3b9191c90eecded3/c67bf49259dce1e180324b942fef6f74.png"
                alt="Villarreal Enterprise Group Logo"
                className="h-9 w-auto"
              />
              <div className="ml-3">
                <div className="text-base font-bold text-white">Villarreal Enterprise Group</div>
                <div className="text-xs text-amber-500/60 tracking-widest uppercase">Las Vegas, Nevada</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm mb-6 max-w-sm leading-relaxed">
              Parent company of <span className="text-amber-400">Speedy DMV Services™</span> &amp;{' '}
              <span className="text-amber-400">DMV-Xpress Services™</span>. Simplifying essential
              services for the Las Vegas community.
            </p>
            <div className="flex space-x-3">
              {[
                { icon: 'ri-facebook-fill', href: '#' },
                { icon: 'ri-twitter-x-line', href: '#' },
                { icon: 'ri-linkedin-fill', href: '#' },
                { icon: 'ri-instagram-line', href: '#' },
              ].map((social, i) => (
                <a
                  key={i}
                  href={social.href}
                  className="w-9 h-9 flex items-center justify-center bg-gray-900 border border-gray-800 hover:border-amber-500/40 hover:text-amber-400 text-gray-400 rounded-lg transition-all duration-300 cursor-pointer"
                >
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xs font-semibold text-amber-400 tracking-widest uppercase mb-5">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { label: 'Home', href: '/' },
                { label: 'About Us', href: '/about' },
                { label: 'Our Brands', href: '/brands' },
                { label: 'Services', href: '/services' },
                { label: 'Contact', href: '/contact' },
                { label: 'Careers', href: '/contact' },
              ].map((link, i) => (
                <li key={i}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-amber-400 text-sm transition-colors duration-300 flex items-center gap-1.5 group cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line text-amber-500/0 group-hover:text-amber-500/80 transition-all duration-300 text-xs"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xs font-semibold text-amber-400 tracking-widest uppercase mb-5">Contact Info</h3>
            <div className="space-y-4">
              {[
                { icon: 'ri-mail-line', text: 'info@villarrealgroup.com' },
                { icon: 'ri-map-pin-2-line', text: 'Las Vegas, Nevada' },
                { icon: 'ri-time-line', text: 'Mon–Fri, 9am–5pm' },
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="w-7 h-7 flex items-center justify-center shrink-0 mt-0.5">
                    <i className={`${item.icon} text-amber-400 text-base`}></i>
                  </div>
                  <span className="text-gray-400 text-sm leading-relaxed">{item.text}</span>
                </div>
              ))}
            </div>

            <div className="mt-6 p-4 bg-amber-500/5 border border-amber-500/15 rounded-xl">
              <div className="text-xs text-amber-400 font-semibold mb-1 uppercase tracking-wide">Our Brands</div>
              <div className="text-xs text-gray-400">Speedy DMV Services™</div>
              <div className="text-xs text-gray-400">DMV-Xpress Services™</div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
            <p className="text-gray-500 text-xs">
              © 2024 Villarreal Enterprise Group, LLC. All rights reserved.
            </p>
            <p className="text-gray-600 text-xs">
              Operated by The Villarreal Organization, Inc
            </p>
            <a
              href="https://readdy.ai/?origin=logo"
              className="text-gray-600 hover:text-amber-400 text-xs cursor-pointer transition-colors duration-300"
            >
              Built with Readdy.ai
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
